module.exports = __webpack_public_path__ + "img/DCM_brain_icon@2x.8e4ce9d1.png";